import React, { useContext } from "react";
import {
  Grid,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import i18next from "i18next";
import { useParams } from "react-router";
import { ERROR } from "../../services/common/Constants";
import {
  checkThirdpartyCode,
  updateTPCode,
} from "../../services/edge/ThirdpartyService";
import { isEmpty } from "../../services/common/Utils";
import { Context } from "../../states/Store";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import useStyles from "../../style/js-style/components/thirdparties/ThirdpartyUpdateDialogStyle";
import EAButton from '../common/EAButton';
import EAColorIcon from '../common/EAColorIcon';

const FORM_ID = "tp-update-form-id";
const tpCodeMaxLength = 255;

const ThirdpartyCodeUpdate = ({
  tpCode,
  onTpCodeChange,
  handleClose,
  thirdpartyId
}) => {
  const { classes } = useStyles();
  const [dispatch] = useContext(Context);
  const { accountId } = useParams();

  const {
    control,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm({ mode: "onChange", delayError: 500 });

  const verifyThirdpartyCode = AwesomeDebouncePromise(async (value) => {
    if (value && value.trim() !== "") {
      try {
        const thirdPartyToUpdate = {
          supplierCode: value.trim(),
        };
        await checkThirdpartyCode(accountId, thirdpartyId, thirdPartyToUpdate, null);
      } catch (error) {
        if (
          error?.message?.messages?.error &&
          error?.message?.messages?.error[0]?.code
        ) {
          return i18next.t(`infos.${error.message.messages.error[0].code}`);
        } else {
          return i18next.t("infos.INTERNAL_ERROR");
        }
      }
    }
  }, 1000);

  const handleCreation = async (data) => {
    if (isEmpty(errors)) {
      const thirdPartyToUpdate = {
        supplierCode: data.tpCode.trim(),
      };
      try {
        await updateTPCode(
          accountId,
          thirdpartyId,
          thirdPartyToUpdate,
          dispatch
        );
        onTpCodeChange(data.tpCode);
        handleClose();
      } catch (error) {
        if (
          error?.message?.messages?.error &&
          error?.message?.messages?.error[0]?.code
        ) {
          setError("tpCode", {
            message: i18next.t(`infos.${error.message.messages.error[0].code}`),
          });
        } else {
          dispatch({
            type: "ALERT",
            alert: { type: ERROR, msg: "TP_CODE_EDIT_ERROR" },
          });
          handleClose();
        }
      }
    }
  };

  return (
    <form id={FORM_ID} onSubmit={handleSubmit(handleCreation)} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: "5px" }}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12}>
          <Controller
            control={control}
            name="tpCode"
            defaultValue={tpCode || ""}
            rules={{
              maxLength: {
                value: tpCodeMaxLength,
                message: i18next.t("infos.E011_VAR", {
                  input: i18next.t("theTpCode"),
                  maxLength: tpCodeMaxLength,
                }),
              },
              validate: (value) => verifyThirdpartyCode(value),
            }}
            render={({ field }) => (
              <TextField
                id="tpCode"
                placeholder={i18next.t("thirdpartySheet.thirdCodePlaceholder")}
                className={classes.descriptionInput}
                variant="outlined"
                error={!!errors.tpCode}
                fullWidth
                helperText={!!errors.tpCode ? errors.tpCode.message : ""}
                {...field}
              />
            )}
          />
        </Grid>
      </Grid>

      <EAButton
        type={"submit"}
        content={<EAColorIcon icon={"valid"} color={"#535362"} width={"10px"}/>}
        customStyle={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #F2F3F7",
          padding: "0 !important",
          minWidth: "24px",
          minHeight: "24px",
          height: "24px",
          borderRadius: "6px",
          boxShadow: "none",
        }}
      />

      <EAButton
        onClick={(e) => {
          e.stopPropagation();
          handleClose()
        }}
        type={"button"}
        content={<EAColorIcon icon={"cross"} color={"#535362"} width={"10px"} />}
        customStyle={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #F2F3F7",
          padding: "0 !important",
          minWidth: "24px",
          width: "24px",
          minHeight: "24px",
          height: "24px",
          borderRadius: "6px",
          boxShadow: "none",
        }}
      />
    </form>
  );
};

export default ThirdpartyCodeUpdate;
